export const FILE_TYPE = {
  IMAGE: ['jpeg', 'jpg', 'png', 'tiff', 'tif', 'nef', 'cr2', 'eps', 'svg', 'psd', 'ai', 'mangodcm', 'arw', 'dng'],
  DOCUMENT: ['doc', 'docx', 'txt', 'pptx', 'ppt', 'xls', 'xlsx', 'pdf', 'html'],
  ARCHIVE: ['zip'],
  VIDEO: ['mov', 'avi', 'mpeg', 'mpg', 'divx', 'dvx', 'mp4', 'm4v', 'wmv', 'mxf', 'ts', 'mts'],
  AUDIO: ['mp3', 'wav'],
  DICOM: ['dicom']
}
